import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UserAuthService {
  constructor(private _http: HttpClient) {
    // afAuth.authState.subscribe(auth => {
    //   this.authState = auth;
    // });
  }

  public signIn(user) {
    return this._http
      .post('/api/sign-in', user)
      .toPromise()
      .catch(error => console.log(error));
  }

  public getAllUsers() {
    return this._http
      .get('/api/users')
      .map((response: Response) => response)
      .toPromise()
      .catch(error => console.log(error));
  }

  // get authenticated(): boolean {
  //   return this.authState !== null;
  // }

  // get currentUser(): any {
  //   return this.authenticated ? this.authState.auth : null;
  // }
}



// WEBPACK FOOTER //
// ./src/app/services/user-auth/user-auth.service.ts